(function($) {
	
	$('.wpp-list').slick({
		prevArrow: '<a href="#" class="slick-arrow prev"><i class="fas fa-chevron-left"></i></a>',
		nextArrow: '<a href="#" class="slick-arrow next"><i class="fas fa-chevron-right"></i></a>',
	});

})(jQuery);